import { render, staticRenderFns } from "./discover-banner.vue?vue&type=template&id=96fcb34e&scoped=true"
import script from "./discover-banner.vue?vue&type=script&lang=js"
export * from "./discover-banner.vue?vue&type=script&lang=js"
import style0 from "./discover-banner.vue?vue&type=style&index=0&id=96fcb34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fcb34e",
  null
  
)

export default component.exports